import { RazorMenuFragment, RazorTextTrim } from "../../components/razor-reuse";
import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ALL_ICONS } from "../../assets/icons/AllIcons";
import CollapseFragment from "../../components/fragment/collapse/CollapseFragment";
import ActionContext from "../../context/ActionContext";
import { ALL_ROUTES } from "../../routes/AllRoutes";
import "../../styles/layout/SideMenuComp.css";
import { useSelector } from "react-redux";
import RootState from "../../redux/type";
import { hasRateIntelligenceRole, systemRoles } from "../../utils/roles";

interface myComponentProps {
  collapse?: boolean;
}

const SideMenuComp = ({ collapse }: myComponentProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  const actionCtx = useContext(ActionContext);

  const sideMenuList = [
    {
      name: "Dashboard",
      icon: ALL_ICONS?.overview,
      icon_two: ALL_ICONS?.overview_white,
      link: ALL_ROUTES?.DASHBOARD_OVERVIEW,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_OVERVIEW),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_OVERVIEW],
      hide: false,
      // hide: !user?.permissions?.includes("view_chart"),
    },
    {
      name: "Transactions",
      icon: ALL_ICONS?.transaction,
      icon_two: ALL_ICONS?.transaction_white,
      link: ALL_ROUTES?.DASHBOARD_TRANSACTION,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_TRANSACTION),
      relatedLinks: [
        ALL_ROUTES?.DASHBOARD_TRANSACTION,
        ALL_ROUTES?.DASHBOARD_TRANSACTION_WEB,
        ALL_ROUTES?.DASHBOARD_TRANSACTION_BUSINESS,
        ALL_ROUTES?.DASHBOARD_TRANSACTION_MOBILE,
        ALL_ROUTES?.DASHBOARD_TRANSACTION_QUEUING,
      ],
      hide: !user?.permissions?.includes(systemRoles[11]),
      children: [
        {
          name: "Mobile Transactions",
          icon: ALL_ICONS?.transaction,
          icon_two: ALL_ICONS?.transaction_white,
          link: ALL_ROUTES?.DASHBOARD_TRANSACTION_MOBILE,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_TRANSACTION_MOBILE,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION_MOBILE],
          hide: !user?.permissions?.includes(systemRoles[11]),
        },
        // {
        //   name: "Web Transactions",
        //   icon: ALL_ICONS?.transaction,
        //   icon_two: ALL_ICONS?.transaction_white,
        //   link: ALL_ROUTES?.DASHBOARD_TRANSACTION_WEB,
        //   active: location?.pathname?.includes(
        //     ALL_ROUTES?.DASHBOARD_TRANSACTION_WEB
        //   ),
        //   relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION_WEB],
        //   hide: !user?.permissions?.includes(systemRoles[11]),
        // },
        {
          name: "Business Transactions",
          icon: ALL_ICONS?.transaction,
          icon_two: ALL_ICONS?.transaction_white,
          link: ALL_ROUTES?.DASHBOARD_TRANSACTION_BUSINESS,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_TRANSACTION_BUSINESS,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION_BUSINESS],
          hide: !user?.permissions?.includes(systemRoles[11]),
        },
        {
          name: "Zojapay Transactions",
          icon: ALL_ICONS?.transaction,
          icon_two: ALL_ICONS?.transaction_white,
          link: ALL_ROUTES?.DASHBOARD_TRANSACTION_ZOJAPAY,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_TRANSACTION_ZOJAPAY,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION_ZOJAPAY],
          hide: !user?.permissions?.includes("view_partner_transactions"),
        },
        {
          name: "Bridge Transactions",
          icon: ALL_ICONS?.transaction,
          icon_two: ALL_ICONS?.transaction_white,
          link: ALL_ROUTES?.DASHBOARD_TRANSACTION_BRIDGE,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_TRANSACTION_BRIDGE,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION_BRIDGE],
          hide: !user?.permissions?.includes("view_partner_transactions"),
        },
        {
          name: "Stripe Transactions",
          icon: ALL_ICONS?.transaction,
          icon_two: ALL_ICONS?.transaction_white,
          link: ALL_ROUTES?.DASHBOARD_TRANSACTION_STRIPE,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_TRANSACTION_STRIPE,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION_STRIPE],
          hide: !user?.permissions?.includes("view_partner_transactions"),
        },
        {
          name: "Plaid Transactions",
          icon: ALL_ICONS?.transaction,
          icon_two: ALL_ICONS?.transaction_white,
          link: ALL_ROUTES?.DASHBOARD_TRANSACTION_PLAID,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_TRANSACTION_PLAID,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION_PLAID],
          hide: !user?.permissions?.includes("view_partner_transactions"),
        },
        {
          name: "Queue Transactions",
          icon: ALL_ICONS?.transaction,
          icon_two: ALL_ICONS?.transaction_white,
          link: ALL_ROUTES?.DASHBOARD_TRANSACTION_QUEUING,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_TRANSACTION_QUEUING,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION_QUEUING],
          hide: !user?.permissions?.includes(systemRoles[11]),
        },
      ],
    },
    {
      name: "Users",
      icon: ALL_ICONS?.customer,
      icon_two: ALL_ICONS?.customer_white,
      link: ALL_ROUTES?.DASHBOARD_CUSTOMER,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_CUSTOMER),
      relatedLinks: [
        ALL_ROUTES?.DASHBOARD_CUSTOMER,
        ALL_ROUTES?.DASHBOARD_CUSTOMER_BUSINESS,
        ALL_ROUTES?.DASHBOARD_CUSTOMER_WEB,
      ],
      hide: !user?.permissions?.includes(systemRoles[3]),
      children: [
        {
          name: "Mobile Users",
          icon: ALL_ICONS?.customer,
          icon_two: ALL_ICONS?.customer_white,
          link: ALL_ROUTES?.DASHBOARD_CUSTOMER,
          active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_CUSTOMER),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_CUSTOMER],
          hide: !user?.permissions?.includes(systemRoles[3]),
        },
        // {
        //   name: "Web Users",
        //   icon: ALL_ICONS?.customer,
        //   icon_two: ALL_ICONS?.customer_white,
        //   link: ALL_ROUTES?.DASHBOARD_CUSTOMER_WEB,
        //   active: location?.pathname?.includes(
        //     ALL_ROUTES?.DASHBOARD_CUSTOMER_WEB
        //   ),
        //   relatedLinks: [ALL_ROUTES?.DASHBOARD_CUSTOMER_WEB],
        //   hide: !user?.permissions?.includes(systemRoles[3]),
        // },
        {
          name: "Business Users",
          icon: ALL_ICONS?.customer,
          icon_two: ALL_ICONS?.customer_white,
          link: ALL_ROUTES?.DASHBOARD_CUSTOMER_BUSINESS,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_CUSTOMER_BUSINESS,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_CUSTOMER_BUSINESS],
          hide: !user?.permissions?.includes(systemRoles[3]),
        },
        {
          name: "Deleted Users",
          icon: ALL_ICONS?.customer,
          icon_two: ALL_ICONS?.customer_white,
          link: ALL_ROUTES?.DASHBOARD_DELETED_CUSTOMERS,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_DELETED_CUSTOMERS,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_DELETED_CUSTOMERS],
          hide: false,
        },
      ],
    },
    {
      name: "Ledger",
      icon: ALL_ICONS?.ledger,
      icon_two: ALL_ICONS?.ledger_white,
      link: ALL_ROUTES?.DASHBOARD_LEDGER,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_LEDGER),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_LEDGER],
      hide: !user?.permissions?.includes(systemRoles[45]),
    },
    {
      name: "Reports",
      icon: ALL_ICONS?.report,
      icon_two: ALL_ICONS?.report_white,
      link: ALL_ROUTES?.DASHBOARD_REPORT,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_REPORT),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_REPORT],
      hide: !user?.permissions?.includes(systemRoles[14]),
    },
    {
      name: "Referral",
      icon: ALL_ICONS?.referral,
      icon_two: ALL_ICONS?.referral_white,
      link: ALL_ROUTES?.DASHBOARD_REFERRAL,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_REFERRAL),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_REFERRAL],
      hide: !user?.permissions?.includes("view_referral_setting"),
    },
    {
      name: "Notification",
      icon: ALL_ICONS?.notification,
      icon_two: ALL_ICONS?.notification_white,
      link: ALL_ROUTES?.DASHBOARD_NOTIFICATION_MANAGEMENT,
      active: location?.pathname?.includes(
        ALL_ROUTES?.DASHBOARD_NOTIFICATION_MANAGEMENT,
      ),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_NOTIFICATION_MANAGEMENT],
      hide: false,
    },
    {
      name: "Feature Management",
      icon: ALL_ICONS?.feature,
      icon_two: ALL_ICONS?.feature_white,
      link: ALL_ROUTES?.DASHBOARD_FEATURE_MANAGEMENT,
      active: location?.pathname?.includes(
        ALL_ROUTES?.DASHBOARD_FEATURE_MANAGEMENT,
      ),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_FEATURE_MANAGEMENT],
      hide: !user?.permissions?.includes(systemRoles[33]),
    },
    {
      name: "Exports",
      icon: ALL_ICONS?.export_logo,
      icon_two: ALL_ICONS?.export_logo_white,
      link: ALL_ROUTES?.DASHBOARD_EXPORT,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_EXPORT),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_EXPORT],
      hide: !user?.permissions?.includes(systemRoles[34]),
    },
    // {
    //   name: "Verification",
    //   icon: ALL_ICONS?.reconcilation,
    //   icon_two: ALL_ICONS?.reconcilation_white,
    //   // link: ALL_ROUTES?.DASHBOARD_CUSTOMER,
    //   // active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_CUSTOMER),
    //   // relatedLinks: [ALL_ROUTES?.DASHBOARD_CUSTOMER],
    // },
    // {
    //   name: "Reconciliation",
    //   icon: ALL_ICONS?.reconcilation,
    //   icon_two: ALL_ICONS?.reconcilation_white,
    //   // link: ALL_ROUTES?.DASHBOARD_CUSTOMER,
    //   // active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_CUSTOMER),
    //   // relatedLinks: [ALL_ROUTES?.DASHBOARD_CUSTOMER],
    // },
    // {
    //   name: "Settlement",
    //   icon: ALL_ICONS?.settlement,
    //   icon_two: ALL_ICONS?.settlement_white,
    //   // link: ALL_ROUTES?.DASHBOARD_CUSTOMER,
    //   // active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_CUSTOMER),
    //   // relatedLinks: [ALL_ROUTES?.DASHBOARD_CUSTOMER],
    // },
  ];

  const sideMenuListTwo = [
    {
      name: "Team Management",
      icon: ALL_ICONS?.users,
      icon_two: ALL_ICONS?.users_white,
      link: ALL_ROUTES?.DASHBOARD_USERS,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_USERS),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_USERS],
      hide: !user?.permissions?.includes(systemRoles[19]),
    },
    {
      name: "Team Activity Logs",
      icon: ALL_ICONS?.user_activity,
      icon_two: ALL_ICONS?.user_activity_white,
      link: ALL_ROUTES?.DASHBOARD_USER_ACTIVITY,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_USER_ACTIVITY),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_USER_ACTIVITY],
      hide: !user?.permissions?.includes(systemRoles[1]),
    },
    {
      name: "Rate Intelligence",
      icon: ALL_ICONS?.rate_intelligence,
      icon_two: ALL_ICONS?.rate_intelligence_white,
      link: ALL_ROUTES?.DASHBOARD_RATE_INTELLIGENCE,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_RATE_INTELLIGENCE),
      relatedLinks: [ALL_ROUTES?.DASHBOARD_RATE_INTELLIGENCE],
      // Visible if the user can see at least one tab (Comparison/History
      // need view_rate_comparison, Alerts needs view_rate_alert) and holds
      // the Super Admin/Finance role required for the module as a whole.
      hide:
        !(
          user?.permissions?.includes("view_rate_comparison") ||
          user?.permissions?.includes("view_rate_alert")
        ) || !hasRateIntelligenceRole(user),
    },
    {
      name: "Roles",
      icon: ALL_ICONS?.roles,
      icon_two: ALL_ICONS?.roles_white,
      link: ALL_ROUTES?.DASHBOARD_ROLES,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_ROLES),
      hide: !user?.permissions?.includes(systemRoles[23]),
      // relatedLinks: [ALL_ROUTES?.DASHBOARD_TRANSACTION],
    },
    // {
    //   name: "Support",
    //   icon: ALL_ICONS?.support,
    //   icon_two: ALL_ICONS?.support_white,
    //   // link: ALL_ROUTES?.DASHBOARD_CUSTOMER,
    //   // active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_CUSTOMER),
    //   // relatedLinks: [ALL_ROUTES?.DASHBOARD_CUSTOMER],
    // },
    {
      name: "Third-Party",
      icon: ALL_ICONS?.side_menu_third_party,
      icon_two: ALL_ICONS?.side_menu_third_party_white,
      link: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_CONTROL_PANEL,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_THIRD_PARTY),
      relatedLinks: [
        ALL_ROUTES?.DASHBOARD_THIRD_PARTY,
        ALL_ROUTES?.DASHBOARD_THIRD_PARTY_BLAZE,
        ALL_ROUTES?.DASHBOARD_THIRD_PARTY_CONTROL_PANEL,
        ALL_ROUTES?.DASHBOARD_THIRD_PARTY_PAYAZA,
      ],
      hide: !user?.permissions?.includes(systemRoles[29]),
      children: [
        {
          name: "Accounts",
          icon: ALL_ICONS?.side_menu_third_party,
          icon_two: ALL_ICONS?.side_menu_third_party_white,
          link: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_PAYAZA,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_THIRD_PARTY,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_THIRD_PARTY],
          hide: false,
        },
        {
          name: "Control Panel",
          icon: ALL_ICONS?.side_menu_third_party,
          icon_two: ALL_ICONS?.side_menu_third_party_white,
          link: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_CONTROL_PANEL,
          active: location?.pathname?.includes(
            ALL_ROUTES?.DASHBOARD_THIRD_PARTY_CONTROL_PANEL,
          ),
          relatedLinks: [ALL_ROUTES?.DASHBOARD_THIRD_PARTY_CONTROL_PANEL],
          hide: !user?.permissions?.includes(systemRoles[41]),
        },
      ],
    },

    {
      name: "Settings",
      icon: ALL_ICONS?.settings,
      icon_two: ALL_ICONS?.settings_white,
      link: ALL_ROUTES?.DASHBOARD_SETTINGS_PROFILE,
      active: location?.pathname?.includes(ALL_ROUTES?.DASHBOARD_SETTINGS),
      // relatedLinks: [ALL_ROUTES?.DASHBOARD_CUSTOMER],
    },
  ];
  return (
    <div
      style={{ paddingLeft: actionCtx?.collapse ? "1rem" : "2rem" }}
      className="side-menu-component-wrapper-index"
    >
      <div className="nav-link-list-box">
        {sideMenuList?.map((chi, idx) => {
          if (chi?.hide) {
            return <React.Fragment key={idx}></React.Fragment>;
          }
          if (Number(chi?.children?.length) > 0) {
            return (
              <div key={idx} className="nav-link-children-box">
                <CollapseFragment
                  collapseHeight="45rem"
                  title={RazorTextTrim(chi?.name, 15)}
                  titleColor="rgba(89, 96, 128, 1)"
                  hideCollapseIcon={false}
                  icon={chi?.active ? chi?.icon : chi?.icon}
                  style={{ gap: "unset" }}
                  collapse={
                    actionCtx?.sideMenuCollapse &&
                    chi?.relatedLinks?.includes(
                      actionCtx?.sideMenuCollapse as string,
                    )
                      ? false
                      : true
                  }
                  disableDefaultControl
                  onCollapse={() => {
                    if (
                      chi?.relatedLinks?.includes(
                        actionCtx?.sideMenuCollapse as string,
                      )
                    ) {
                      actionCtx?.setSideMenuCollapse?.("");
                    } else {
                      actionCtx?.setSideMenuCollapse?.(chi?.relatedLinks[0]);
                    }
                  }}
                >
                  {" "}
                  <div className="children-list-box">
                    {chi?.children?.map((child, index) => {
                      if (child?.hide) {
                        return <React.Fragment key={idx}></React.Fragment>;
                      }
                      return (
                        <RazorMenuFragment
                          activeBgColor="rgba(115, 71, 146, 1)"
                          key={index}
                          text={RazorTextTrim(child?.name, 15)}
                          icon={child?.active ? child?.icon_two : child?.icon}
                          active={child?.active}
                          activeTextColor={`#ffffff`}
                          className={`smartsend-menu-box`}
                          collapse={actionCtx?.collapse}
                          onClick={() => {
                            if (child?.link) {
                              navigate(child?.link);
                            }
                          }}
                        />
                      );
                    })}
                  </div>
                </CollapseFragment>
              </div>
            );
          }
          return (
            <RazorMenuFragment
              activeBgColor="rgba(115, 71, 146, 1)"
              //   activeDirection="right"
              // type="two"
              key={idx}
              text={RazorTextTrim(chi?.name, 15)}
              icon={chi?.active ? chi?.icon_two : chi?.icon}
              active={chi?.active}
              activeTextColor={`#ffffff`}
              className={`smartsend-menu-box`}
              collapse={actionCtx?.collapse}
              onClick={() => {
                if (chi?.link) {
                  actionCtx?.setSideMenuCollapse?.("");
                  navigate(chi?.link);
                }
              }}
            />
          );
        })}

        <CollapseFragment
          collapseHeight="45rem"
          title={"More"}
          titleColor="rgba(89, 96, 128, 1)"
          hideCollapseIcon={actionCtx?.collapse}
        >
          <div className="gap-box-reuse">
            {sideMenuListTwo?.map((chi: any, idx) => {
              if (chi?.hide) {
                return <React.Fragment key={idx}></React.Fragment>;
              }
              if (Number(chi?.children?.length) > 0) {
                return (
                  <div key={idx} className="nav-link-children-box">
                    <CollapseFragment
                      collapseHeight="45rem"
                      title={RazorTextTrim(chi?.name, 15)}
                      titleColor="rgba(89, 96, 128, 1)"
                      hideCollapseIcon={false}
                      icon={chi?.active ? chi?.icon : chi?.icon}
                      style={{ gap: "unset" }}
                      collapse={
                        actionCtx?.sideMenuCollapse &&
                        chi?.relatedLinks?.includes(
                          actionCtx?.sideMenuCollapse as string,
                        )
                          ? false
                          : true
                      }
                      disableDefaultControl
                      onCollapse={() => {
                        if (
                          chi?.relatedLinks?.includes(
                            actionCtx?.sideMenuCollapse as string,
                          )
                        ) {
                          actionCtx?.setSideMenuCollapse?.("");
                        } else {
                          actionCtx?.setSideMenuCollapse?.(
                            chi?.relatedLinks[0],
                          );
                        }
                      }}
                    >
                      {" "}
                      <div className="children-list-box">
                        {chi?.children?.map((child: any, index: any) => {
                          if (child?.hide) {
                            return <React.Fragment key={idx}></React.Fragment>;
                          }
                          return (
                            <RazorMenuFragment
                              activeBgColor="rgba(115, 71, 146, 1)"
                              key={index}
                              text={RazorTextTrim(child?.name, 15)}
                              icon={
                                child?.active ? child?.icon_two : child?.icon
                              }
                              active={child?.active}
                              activeTextColor={`#ffffff`}
                              className={`smartsend-menu-box`}
                              collapse={actionCtx?.collapse}
                              onClick={() => {
                                if (child?.link) {
                                  navigate(child?.link);
                                }
                              }}
                            />
                          );
                        })}
                      </div>
                    </CollapseFragment>
                  </div>
                );
              }

              return (
                <RazorMenuFragment
                  activeBgColor="rgba(115, 71, 146, 1)"
                  //   activeDirection="right"
                  // type="two"
                  key={idx}
                  text={
                    chi?.name === "Third-Party Application"
                      ? RazorTextTrim(chi?.name, 15)
                      : chi?.name
                  }
                  icon={chi?.active ? chi?.icon_two : chi?.icon}
                  active={chi?.active}
                  activeTextColor={`#ffffff`}
                  className={`smartsend-menu-box`}
                  collapse={actionCtx?.collapse}
                  onClick={() => {
                    if (chi?.link) {
                      actionCtx?.setSideMenuCollapse?.("");
                      navigate(chi?.link);
                    }
                  }}
                />
              );
            })}
          </div>
        </CollapseFragment>
      </div>
      {/* logout box start */}
      <div className="logout-box">
        <RazorMenuFragment
          collapse={actionCtx?.collapse}
          className="logout"
          activeTextColor="rgba(89, 96, 128, 1)"
          icon={ALL_ICONS?.logout}
          text="Logout"
          onClick={() => {
            actionCtx?.setLogout?.(true);
          }}
        />
      </div>
      {/* logout box end */}
    </div>
  );
};

export default SideMenuComp;
